import React from 'react';
import ConditionalDisplay from './ConditionalDisplay';

interface LoadingProps {
  loading: boolean,
};

const Loading = ({ loading }: LoadingProps) => {
  return (
    <ConditionalDisplay condition={ loading } trueDisplay={ <div className='spinner-border' /> } falseDisplay={ null } />
  );
};

export default Loading;